import { Component, OnInit } from '@angular/core';
import { ReservationTenantService, CommonService } from '../../../services';
import { ReservationDto } from '../../../models';
import { MessageService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import * as globals from '../../../globals';

@Component({
    selector: 'app-reservation-tenants-details',
    templateUrl: './details.component.html',
    styleUrls: ['./details.component.css']
})
export class ReservationTenantsDetailsComponent implements OnInit {
    reservation: ReservationDto = new ReservationDto();
    companies: SelectItem[];
    carparks: SelectItem[];
    paymentModes: SelectItem[] = [{ value: 'Full', label: 'Opłaca gość' }, { value: 'Discount_100', label: 'Firma pokrywa całość pobytu' }, { value: 'Discount_TimeRange', label: 'Firma pokrywa czas rezerwacji' }];
    pl = globals.pl;

    constructor(
        private reservationService: ReservationTenantService,
        private messageService: MessageService,
        private commonsService: CommonService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location
    ) { }

    ngOnInit() {
        this.reservationService.getPermittedCompanies().subscribe(
            companies => this.companies = companies.map(
                c => {
                    return { label: c.name, value: c.id };
                }
            ),
            error => {
                console.error(error);
            }
        );
        this.commonsService.getCarParks().subscribe(
            carparks => this.carparks = carparks.map(
                c => {
                    return { label: c.name, value: c.id };
                }
            ),
            error => {
                console.error(error);
            }
        );
        this.reservation.dateFrom = new Date();
        this.route.paramMap.subscribe(value => {
            let idReservation: number = +value.get("id");
            if (idReservation != null) {
                this.reservationService.getReservation(idReservation).subscribe(
                    reservation => {
                        if (reservation) {
                            this.reservation = reservation
                            this.reservation.dateFrom = new Date(reservation.dateFrom);
                            this.reservation.dateUntil = new Date(reservation.dateUntil);
                        }
                    },
                    error => {
                        console.error(error);
                    }
                );
            }
        });
    }

    addReservation() {
        console.log(this.reservation);
        if (this.reservation.carparkId == null || this.reservation.tenantId == null || !this.reservation.dateFrom || !this.reservation.dateUntil || !this.reservation.email || this.reservation.paymentMode == null) {
            this.messageService.add({ severity: 'error', summary: 'Wymagane pola', detail: 'Pola z gwiazką (*) są wymagane.' });
        }
        this.reservationService.addReservation(this.reservation).subscribe(
            () => {
                this.messageService.add({ severity: 'success', summary: 'Zapisano rezerwację', detail: '' });
                this.router.navigate(['/reservation']);
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Błąd zapisu rezerwacji', detail: error });
            }
        );
    }

    cancelReservation() {
        this.reservationService.cancelReservation(this.reservation.id).subscribe(
            () => {
                this.messageService.add({ severity: 'success', summary: 'Anulowano rezerwację' });
                this.router.navigate(['/reservation']);
            },
            (error) => this.messageService.add({ severity: 'error', summary: 'Błąd anulowania rezerwacji', detail: error })
        );
    }

    cancel(): void {
        this.location.back();
    }
}
